import { p as public_env } from "./shared-server.js";
const INSTANCE_MODE = public_env.PUBLIC_INSTANCE_MODE?.toUpperCase();
const isOn = (env2) => env2?.toLowerCase() === "on";
const privateInstance = INSTANCE_MODE === "PRIVATE";
const publicOnlyInstance = INSTANCE_MODE === "PUBLIC_ONLY";
export {
  privateInstance as a,
  isOn as i,
  publicOnlyInstance as p
};
